.full-screen :host {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

:host {
  display: block;
  width: 700px;
  height: 500px;
  position: relative;
}

:host.vertical {
  height: 560px;
  width: 550px;
}

.is-mobile-viewport :host {
  max-width: var(--mobile-max-width);
  min-width: var(--mobile-min-width);
  aspect-ratio: var(--mobile-aspect-ratio);
}

.container {
  position: relative;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  border-radius: var(--layout-border-radius, 0px);
  overflow: hidden;
}

.row-reverse {
  flex-direction: row-reverse;
}

.is-mobile-viewport,
.vertical {
  flex-direction: column;
}

.column-reverse {
  flex-direction: column-reverse;
}

.container > div {
  flex: 1 0 50%;
}

.vertical.container > div {
  flex: 1 0 40%;
}

.vertical.container > div:last-child {
  flex: 1 0 60%;
}

.is-mobile-viewport.container > div:first-child {
  flex: 0 0 197px;
}

.max-size.is-mobile-viewport.container > div:first-child {
  flex: 0 0 263px;
}

.form-panel {
  background-color: #fff;
  min-height: 0;
}

.screen-container {
  position: static !important;
  height: 100%;
  background-color: var(--textBlockBgColour, #fff);
}

/* Acquisition screens have .copy-container as flex container */
.screen-container .copy-container {
  justify-content: flex-end !important;
}

.is-mobile-viewport .screen-container .copy-container {
  flex: unset !important;
  justify-content: unset !important;
}

/* Acquisition-specific: form inputs and CTA in horizontal layout */
.horizontal .screen-container .input,
.horizontal .screen-container .inputs-container .cta-wrapper {
  width: 100% !important;
}

.horizontal .screen-container .inputs-container {
  gap: 8px !important;
}

.inner-container {
  min-height: 0 !important;
}

.current-screen-background {
  position: static !important;
  height: 100%;
  width: 100%;
}

.screen-container .copy-container .title,
.screen-container .copy-container .body {
  min-height: 0;
}

.is-mobile-viewport .screen-container .title {
  margin-top: 0;
}
